import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { FC, Fragment } from 'react';
import { BlogAuthorDto, BlogPostDto } from '@/components/BlogPage/types';
import Image from '@/components/Image';
import { Typography } from '@/components/shared/Typography';
import { useModal } from '@/hooks/useModal';
import css from './style.module.scss';
interface Props {
  post: BlogPostDto;
}
const getInitials = (name = '') => name.split(' ').filter(Boolean).slice(0, 2).map(part => part[0].toUpperCase()).join('');
const PersonCredit: FC<{
  person: BlogAuthorDto;
  post: BlogPostDto;
  label: string;
}> = t0 => {
  const $ = _c(39);
  const {
    person,
    post,
    label
  } = t0;
  const {
    openModal
  } = useModal();
  const {
    name,
    role,
    avatar,
    seo,
    experience,
    shortBio,
    socials,
    isBookCallAvailable
  } = person;
  let t1;
  if ($[0] !== socials) {
    t1 = socials?.find(_temp);
    $[0] = socials;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const linkedin = t1;
  let t2;
  if ($[2] !== label) {
    t2 = <Typography variant="body-s" tag="p" className={css.label}>{label}</Typography>;
    $[2] = label;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = `/blog/author/${seo.url}`;
  let t4;
  if ($[4] !== post.seo.url) {
    t4 = {
      from: post.seo.url
    };
    $[4] = post.seo.url;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = {
      pathname: t3,
      query: t4
    };
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== avatar || $[10] !== name) {
    t6 = avatar?.url ? <Image src={avatar.url} width={104} height={104} className={css.avatarImage} alt={name} /> : getInitials(name);
    $[9] = avatar;
    $[10] = name;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = <div className={css.avatar}>{t6}</div>;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== name) {
    t8 = <Typography variant="body-l" tag="span" responsive={false} className={css.name}>{name}</Typography>;
    $[14] = name;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== role) {
    t9 = role ? <Typography variant="body-l" tag="span" responsive={false} className={css.role}>{role}</Typography> : null;
    $[16] = role;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t8 || $[19] !== t9) {
    t10 = <span className={css.personInfo}>{t8}{t9}</span>;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t5 || $[23] !== t7) {
    t11 = <Link className={css.personLink} href={t5}>{t7}{t10}</Link>;
    $[21] = t10;
    $[22] = t5;
    $[23] = t7;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== experience) {
    t12 = experience ? <Typography variant="body-s" tag="p" className={css.experience}>{experience}</Typography> : null;
    $[25] = experience;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== shortBio) {
    t13 = shortBio ? <Typography variant="body-l" tag="p" responsive={false} className={css.bio}>{shortBio}</Typography> : null;
    $[27] = shortBio;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== isBookCallAvailable || $[30] !== linkedin || $[31] !== openModal) {
    t14 = linkedin || isBookCallAvailable ? <div className={css.actions}>{linkedin ? <a className={css.action} href={linkedin.url} target="_blank" rel="noopener noreferrer">LinkedIn</a> : null}{isBookCallAvailable ? <button type="button" className={css.action} onClick={() => openModal("CALENDAR_BOOKING")}>Book a call</button> : null}</div> : null;
    $[29] = isBookCallAvailable;
    $[30] = linkedin;
    $[31] = openModal;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t11 || $[34] !== t12 || $[35] !== t13 || $[36] !== t14 || $[37] !== t2) {
    t15 = <div className={css.person}>{t2}{t11}{t12}{t13}{t14}</div>;
    $[33] = t11;
    $[34] = t12;
    $[35] = t13;
    $[36] = t14;
    $[37] = t2;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  return t15;
};
const PostCredits: FC<Props> = t0 => {
  const $ = _c(10);
  const {
    post
  } = t0;
  let t1;
  if ($[0] !== post.author) {
    t1 = post.author ? {
      person: post.author,
      label: "Written by"
    } : null;
    $[0] = post.author;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== post.expert) {
    t2 = post.expert ? {
      person: post.expert,
      label: "Reviewed by"
    } : null;
    $[2] = post.expert;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = [t1, t2].filter(Boolean);
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const credits = t3 as {
    person: BlogAuthorDto;
    label: string;
  }[];
  if (!credits.length) {
    return null;
  }
  let t4;
  if ($[7] !== credits || $[8] !== post) {
    t4 = <section className={css.wrapper}><div className={css.grid}>{credits.map((t5, index) => {
          const {
            person,
            label
          } = t5;
          return <Fragment key={label}>{index > 0 ? <div className={css.divider} /> : null}<PersonCredit person={person} post={post} label={label} /></Fragment>;
        })}</div></section>;
    $[7] = credits;
    $[8] = post;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default PostCredits;
function _temp(social) {
  return social.name === "linkedin";
}